import { emptyApi } from "./emptyApi";

export const userAcceptance = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    saasAgreement: builder.query<string, void>({
      query: () => ({
        url: `https://assets.infraview.app/public/en/SaaS_Agreement_InfraSight.md`,
        responseHandler: (response) => response.text(),
      }),
    }),
    termOfService: builder.query<string, void>({
      query: () => ({
        url: `https://assets.infraview.app/public/en/Terms+of+Service_InfraSight.md`,
        responseHandler: (response) => response.text(),
      }),
    }),
    acceptancePolicy: builder.query<string, void>({
      query: () => ({
        url: `https://assets.infraview.app/public/en/UserAcceptancePolicy_InfraSight.md`,
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useAcceptancePolicyQuery,
  useTermOfServiceQuery,
  useSaasAgreementQuery,
} = userAcceptance;
export default userAcceptance.reducer;
